import React, { useState, useEffect } from 'react';
import AppButton from '../../base/button';
import { FiPlus } from 'react-icons/fi';
import { AppTable } from '../../base/base-table';
import Emptytransaction from '../../../assets/svgs/empty-beneficiary.svg';
import usePayoutStore from '../../../store/payout';
import TransactionDetails from '../transaction-details';
import {
  IGetTransactionParam,
  ITransaction,
} from '../../../models/transaction.model';
import StatusBadge from '../../base/status-badge';
import Pagination from '../../base/pagination';
import DateFilter from '../../base/date-filter';
import FilterDropdown from '../../base/filter-dropdown';
import FilterInput from '../../base/filter-input';
const TransactionsTable = () => {
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] =
    useState<ITransaction | null>(null);
  const {
    getAllTransactions,
    transactionsPagination,
    transactions,
    loading: loadingTransactions,
  } = usePayoutStore();

  const [filters, setFilters] = useState<IGetTransactionParam>({
    page: 1,
    pageSize: 10,
    startDate: '',
    endDate: '',
    status: '',
    beneficiaryName: '',
  });

  useEffect(() => {
    const fetchTransactions = async () => {
      await getAllTransactions(filters);
    };
    fetchTransactions();
  }, [filters]);

  const statuses = [
    'Pending',
    'Approved',
    'Rejected',
    'Successful',
    'Failed',
    'New',
  ];

  const handleViewClick = (transaction: ITransaction) => {
    setSelectedTransaction(transaction);
    setIsViewModalOpen(true);
  };

  const clearFilters = () => {
    setFilters({
      page: 1,
      pageSize: 10,
      startDate: '',
      endDate: '',
      status: '',
      beneficiaryName: '',
    });
  };
  const toggleViewModal = () => {
    setIsViewModalOpen(!isViewModalOpen);
    if (isViewModalOpen) {
      setSelectedTransaction(null);
    }
  };
  const tableHeadings = [
    'Name',
    'Bank',
    'Account Number',
    'Reference',
    'Date',
    'Status',
    'Action',
  ];
  const tableData = transactions.map((tx) => [
    { value: tx.beneficiaryDetail?.customerName || '-' },
    { value: tx.beneficiaryDetail?.bankName || '-' },
    {
      value: (
        <div className="flex flex-col gap-1">
          <p>
            {JSON.parse(tx.beneficiaryDetail?.paymentDetails || '{}')
              ?.AccountNumber || '-'}
          </p>
          <p className="font-light text-sm text-gray-text">
            {tx.toCurrencyCode || '-'}
          </p>
        </div>
      ),
    },
    { value: tx.transactionRef || 'N/A' },
    {
      value: new Date(tx.transactionDate).toLocaleDateString('en-GB') || 'N/A',
    },
    { value: <StatusBadge status={tx.transactionStatus.toLowerCase()} /> },
    {
      value: (
        <button
          className="text-primary hover:text-primary/80 text-sm font-medium"
          onClick={() => handleViewClick(tx)}
        >
          View Details
        </button>
      ),
    },
  ]);

  return (
    <div className="flex flex-col gap-4 rounded-xl border border-[#F1F2F4] bg-white p-6 shadow-sm">
      <div className="flex justify-between items-center">
        <div className="grid gap-2">
          <p className="text-2xl leading-[31.2px] font-bold">Transactions</p>
          <p className="text-sm leading-[22.4px] font-medium text-[#687588]">
            Manage your transactions
          </p>
        </div>
        <div className="w-fit">
          <AppButton icon={<FiPlus />} label="Download History" type="light" />
        </div>
      </div>

      {/* <DateFilter /> */}

      {!!transactions.length && (
        <div className="flex justify-between">
          <div className="w-full flex gap-6">
            <DateFilter
              onFilter={({ startDate, endDate }) =>
                setFilters((prevFilters) => ({
                  ...prevFilters,
                  startDate,
                  endDate,
                }))
              }
            />
            <FilterDropdown
              label="Status"
              options={statuses}
              value={filters.status}
              onSelect={(selectedOption) =>
                setFilters((prevFilters) => ({
                  ...prevFilters,
                  status: selectedOption,
                }))
              }
            />

            <FilterInput
              label="Search"
              type="text"
              filter={(value) => value.length > 2}
              onSearch={(value) =>
                setFilters((prevFilters) => ({
                  ...prevFilters,
                  beneficiaryName: value,
                }))
              }
              placeholder="Search by name..."
            />
          </div>

          {(filters.startDate ||
            filters.endDate ||
            filters.status ||
            filters.beneficiaryName) && (
            <AppButton
              label="Reset"
              type="danger-light"
              size="md"
              fullWidth={false}
              clicked={clearFilters}
            />
          )}
        </div>
      )}

      <AppTable
        loading={loadingTransactions}
        columns={tableHeadings}
        data={tableData}
        emptyState={
          <div className="min-h-[30rem] flex flex-col items-center gap-7 justify-center">
            <img
              src={Emptytransaction}
              alt="No transactions"
              className="h-[100px] w-[100px]"
            />
            <div className="text-center">
              <p className="text-[#1F2937] font-bold text-2xl">
                No transactions found
              </p>
              <p className="text-[#687588] text-sm">
                No transactions available at the moment. Check back later.
              </p>
            </div>
          </div>
        }
      />

      {!!transactions.length && (
        <Pagination
          pageSize={transactionsPagination.currentPageSize}
          currentPage={transactionsPagination.currentPage}
          totalCount={transactionsPagination.totalRecords}
          hasNextPage={transactionsPagination.hasNextPage}
          hasPrevious={transactionsPagination.hasPrevious}
          onPageChange={(page: number) => {
            setFilters((prevFilters) => ({
              ...prevFilters,
              page,
            }));
          }}
          onPageSizeChange={(pageSize: number) => {
            setFilters((prevFilters) => ({
              ...prevFilters,
              pageSize,
            }));
          }}
        />
      )}

      <TransactionDetails
        isOpen={isViewModalOpen}
        toggleModal={toggleViewModal}
        selectedTransaction={selectedTransaction}
      />
    </div>
  );
};
export default TransactionsTable;
